<div id="errorListContainer" class="error-list-container">
  @for (error of errorListResult.errors; track error) {
    <div id="errorContainer" class="error-container">
      <div id="errorHeader" class="error-header">{{error.createdOn | date:appInfoService.dateTimeFormat}}, {{error.errorSource}}</div>
      <mat-divider></mat-divider>
      <div id="errorInfo" class="error-info">{{error.details}}</div>
    </div>
  }

  <div id="errorListButtonsContainer" class="errorList-buttons-container">
    <button mat-button id="copyToClipboard" class="primary button" (click)="copyErrorListToClipboard()">
      {{appStrings.button_errorListCopyToClipboard}}
    </button>
  </div>
  <div id="paginatorContainer" class="flex-container">
    @if (errorListResult.countErrors && errorListResult.errors) {
      <mat-paginator id="errorsListPaginator" [length]="errorListResult.countErrors" [pageSize]="pageSize" [hidePageSize]="true"
        [showFirstLastButtons]="true" (page)="loadPage($event)" [pageIndex]="currentPage">
      </mat-paginator>
    }
  </div>
</div>
